import { HashRouter } from 'react-router-dom';
import './App.scss';
import { AppRouter } from './routes/AppRouter';

function App() {
  return (
    <HashRouter>
    <AppRouter/>
    </HashRouter>
  );
}

export default App;
